<template>
    <structure>
        <section class="load" v-if="load"></section>
        <section class="ouvidoria" v-if="!load">
            <div class="avatar-client">
                <img :src="ticket.client.avatar">
            </div>
            <div class="subtitle">
                <div>
                    <h2>{{ticket.code}} - {{ticket.title}}</h2>
                    <div class="status">
                        <span class="tag progress" v-status="ticket.status"></span>
                    </div>
                    <div class="date">
                        <span>{{ticket.created_at | moment('DD [de] MMMM [de] YYYY [às] H:m[h]')}}</span>
                    </div>
                </div>
            </div>
            <section class="post">
                <div class="text" v-html="ticket.text"></div>
                <div class="anexos" v-if="ticket.files.length">
                    <ul>
                        <li v-for="(file, index) in ticket.files" :key="index">
                            <a :href="file" target="_blank"><img :src="file" height="40"></a>
                        </li>
                    </ul>
                </div>
            </section>
            <div class="comments">
                <div class="title">
                    <h2>Comentários</h2>
                </div>
                <div class="items">
                    <div class="item" v-for="(comment, index) in comments" :key="comment.id">
                        <div class="box">
                            <div class="content">
                                <ui-menu-action class="float">
                                    <li>
                                        <button type="button" @click="editComment(comment, index)">Editar</button>
                                    </li>
                                    <li>
                                        <button type="button" @click="deleteComment(comment, index)">Excluir</button>
                                    </li>
                                </ui-menu-action>
                                <div class="name">{{comment.user.first_name}} {{comment.user.last_name}}:</div>
                                <div class="text">
                                    <p>{{comment.text}}</p>
                                </div>
                                <div class="date"><i class="fal fa-calendar-alt"></i> {{comment.created_at | moment('DD [de] MMMM [de] YYYY [às] H:mm:ss[h]')}}</div>
                            </div>
                            <div class="avatar">
                                <img :src="comment.user.avatar">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <button type="button" @click="openComments()">
                        <i class="fal fa-plus"></i>
                    </button>
                </div>
            </div>
        </section>
        <add-comments-modal :row="id" module="tickets" :comment="comment" />
        <delete-comments-modal :comment="comment" />
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import addCommentsModal from './modal-add-comments'
    import deleteCommentsModal from './modal-delete-comment'
    import { tickets, conversations } from '@/services'
    import { status } from '@/directives'
    import { uiMenuAction } from '@/components'
    export default {
        name: 'login',
        components: { structure, addCommentsModal, uiMenuAction, deleteCommentsModal },
        directives: { status },
        data() {
            return {
                id: null,
                ticket: null,
                load: false,
                comments: [],
                comment: null,
            }
        },
        methods: {
            openComments(){
                this.comment = null
                this.$root.$emit("modal", "add-comments");
            },
            details(){
                this.load = true
                tickets.get(this.id).then( response => {
                    this.ticket = response.data
                    this.load = false
                }, () => {

                    this.$router.push({
                        name: 'access-block',
                        params: {
                            title: 'Acesso não permitido',
                            text: 'Você não tem permissão para acessar essa página',
                        }
                    })
                })
            },
            getConversations(){
                conversations.list('tickets/'+this.id).then( response => {
                    this.comments = response.data.rows
                })
            },
            deleteComment(comment, index){
                this.comment = comment
                this.comment.index = index
                this.$root.$emit('modal', 'delete-comment');
            },
            editComment(comment, index){
                this.comment = comment
                this.comment.index = index
                this.$root.$emit('modal', 'add-comments');
            },
            scrollToBottom(){
                setTimeout(() => {
                    document.getElementsByClassName('app')[0].scrollTo(0,999999999);
                }, 100)
            },
            expireEdit(d){
                let start   = this.$moment(d).add(5, 'm').format('DD/MM/YYYY HH:mm:ss')
                let end     = this.$moment().format('DD/MM/YYYY HH:mm:ss')
                return end > start ? false : true
            }
        },
        created(){
            this.id = this.$route.params.id
            this.details()
            this.getConversations()

            this.$root.$on("reload-comments", (row) => {
                this.comments.push(row)
                this.scrollToBottom()
                this.$root.$emit("modal-close", "add-comments");
                this.comment = null
            })

            this.$root.$on("reload-comment", (row) => {
                this.$set(this.comments[row.index], 'text', row.text)
                this.$root.$emit("modal-close", "add-comments");
                this.comment = null
            })

            this.$root.$on("remove-comment-item", (index) => {
                this.$delete(this.comments, index)
                this.scrollToBottom()
                this.$root.$emit("modal-close", "delete-comment");
                this.comment = null
            })

            this.$root.$on("remove-comment-item", () => {
                this.getConversations()
                this.scrollToBottom()
                this.$root.$emit("modal-close", "delete-comment");
                this.comment = null
            })
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
